/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS203: Remove `|| {}` from converted for-own loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Dispatcher from "Dispatcher";
import DevelopmentActions from "data/dev/DevelopmentActions";

export function extendRight(base, ...others) {
    for (const other of others) {
        for (const key of Object.keys(other || {})) {
            base[key] = other[key];
        }
    }
    return base;
}

export function extendLeft(base, ...others) {
    for (const other of others) {
        for (const key of Object.keys(other || {})) {
            if (!base.hasOwnProperty(key)) {
                base[key] = other[key];
            }
        }
    }
    return base;
}

export const extend = extendRight;

class WindowView extends Backbone.Marionette.CompositeView {
    static initClass() {
        this.prototype.template = require("./templates/window");
    }
}
WindowView.initClass();

class StringView extends Backbone.Marionette.ItemView {
    static initClass() {
        this.prototype.tagName = "li";
    }
    template(model) {
        return model.body;
    }
}
StringView.initClass();

class ErrorList extends Backbone.Marionette.CompositeView {
    static initClass() {
        this.prototype.template = require("./templates/error_list");
        this.prototype.itemView = StringView;
        this.prototype.itemViewContainer = "ul";
    }
}
ErrorList.initClass();

let windowCount = 0;
const itwindow = function(type, title, body = "") {
    const hoffset = windowCount % 5;
    const voffset = Math.floor(windowCount / 5);
    windowCount += 1;
    if (typeof body === "string") {
        body = new StringView({
            model: new Backbone.Model({
                body
            })
        });
    }
    const w = itview(new WindowView({
            model: new Backbone.Model({
                top: 15 + (hoffset * 5) + (voffset * 3),
                left: (30 + (hoffset * 5)) - voffset,
                type: type != null ? type : "default",
                title
            })
        })
    );
    body.setElement(w.find(".panel-body")).render();
    return w;
};

export const itview = function(view) {
    let $el;
    if ($("#IT-UI").length === 0) {
        $("body").append("<div id=\"IT-UI\"></div>");
    }
    $("#IT-UI").append($el = $("<div></div>"));
    view.setElement($el).render();
    return $el.find(".IT-window");
};

export const createCloseable = (closeableSelector, triggerSubselector) =>
    $("body").on("click", closeableSelector + " " + triggerSubselector, function() {
        return $(this).parents(closeableSelector).first().remove();
    });

export const createDraggable = function(draggableSelector, handleSubselector) {
    const getMaxZIndex = function(except) {
        return $(draggableSelector).not(except).map(function() {
            return parseInt($(this).css("z-index"));
        }).sort((a, b) => b - a)[0];
    };
    return $("body").on("mousedown", draggableSelector + " " + handleSubselector, function(e) {
        e.preventDefault();
        const $this = $(this).css({cursor: "move"});
        const $draggable = $this.parents(draggableSelector).first();
        const maxZIndex = getMaxZIndex($draggable.get(0));
        const ps = $draggable.css("z-index", maxZIndex + 1).offset();
        const ds = {
            left: e.pageX,
            top: e.pageY
        };
        const recalc = function(e) {
            const de = {
                left: e.pageX,
                top: e.pageY
            };
            const css = {
                left: ((ps.left + de.left) - ds.left) + "px",
                top: ((ps.top + de.top) - ds.top) + "px"
            };
            return $draggable.css(css);
        };
        let handleMove = null;
        handleMove = function(e) {
            e.preventDefault();
            return recalc(e);
        };
        let handleUp = null;
        handleUp = function(e) {
            e.preventDefault();
            $this.css({cursor: "auto"});
            $("body")
                .off("mouseup", handleUp)
                .off("mousemove", handleMove);
            return recalc(e);
        };
        return $("body")
            .on("mouseup", handleUp)
            .on("mousemove", handleMove);
    }).on("click", draggableSelector, function() {
        const maxZIndex = getMaxZIndex(this);
        return $(this).css("z-index", maxZIndex + 1);
    });
};

const sendStatusMessage = body =>
    // eslint-disable-next-line no-restricted-globals
    top.postMessage(`test-status:${body}`, "*");

export function setUpDOM() {
    $("body").addClass("IT-pending");
    sendStatusMessage("pending");
    createCloseable(".IT-window", ".close");
    return createDraggable(".IT-window", ".panel-heading");
}

const error = e => itwindow("danger", "Error!", e instanceof Error ? e.message : e);

const info = (title, message) => itwindow("info", title, message);

const complete = function(success = true) {
    const $body = $("body");
    $body.removeClass("IT-pending").addClass(success ? "IT-success" : "IT-error").addClass("IT-complete");
    if (success) {
        sendStatusMessage("success");
        Dispatcher.dispatch({
            type: DevelopmentActions.IT_TEST_SUCCESS,
        });
    } else {
        const message = $body.data("error");
        sendStatusMessage(`error:${message}`);
        Dispatcher.dispatch({
            type: DevelopmentActions.IT_TEST_ERROR,
            message,
        });
    }
    return sendStatusMessage("complete");
};

const addErrorData = function(e) {
    const $body = $("body");
    if (($body.data("error") == null)) {
        if (e instanceof Error) {
            $body.attr("data-error", e.message);
            return $body.attr("data-coords", e.line + ":" + e.column);
        } else {
            return $body.attr("data-error", e);
        }
    }
};

export default {
    extend,
    extendLeft,
    extendRight,
    itview,
    createCloseable,
    createDraggable,
    setUpDOM,
    error,
    info,
    complete,
    addErrorData,
};



// WEBPACK FOOTER //
// ./test/it/lib/utils.js